import { ReduxAction } from 'types/redux';
import { actionTypes } from 'actions/customer/actionTypes';

const initState = {
  customers: {},
  publicCustomers: {},
  groups:{},
  createGroup: {},
  membersGroup: {},
  membersApp: {},
  dataInviteMembers: null,
  dataInviteCustomer: null,
  addBrikGroup: null,
  listBriks: {},
  listBriksAddToGroup: {},
  loadingGetListBriksAddToGroup: false,
  loadingCustomer: false,
  loadCreate: false,
};

export default (state = initState, action: ReduxAction) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GET_LIST_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: payload,
      };
    case actionTypes.GET_LIST_PUBLIC_CUSTOMERS_SUCCESS:
      return {
        ...state,
        publicCustomers: payload,
      };
    case actionTypes.GET_LIST_GROUPS_SUCCESS:
      return {
        ...state,
        groups: payload,
      };
    case actionTypes.GET_LIST_BRIKS_SUCCESS:
      return {
        ...state,
        listBriks: payload,
      };
    case actionTypes.GET_LIST_MEMBERS_SUCCESS:
      return {
        ...state,
        membersGroup: payload,
      };
      
    case actionTypes.GET_LIST_MEMBERS_APP_SUCCESS:
      return {
        ...state,
        membersApp: payload,
      };
    case actionTypes.GET_USER_COUNT_SUCCESS:
      return {
        ...state,
        userCount: payload,
      };
      
    case actionTypes.GET_BRIK_PAGE:
      return {
        ...state,
        brikPage: null,
      };
    case actionTypes.GET_BRIK_PAGE_SUCCESS:
      return {
        ...state,
        brikPage: payload,
      };
    case actionTypes.CREATE_GROUP:
      return {
        ...state,
        loadCreate: true,
      };
    case actionTypes.CREATE_GROUP_SUCCESS:
      return {
        ...state,
        addCustomer: payload,
        loadCreate: false,
      };
    case actionTypes.CREATE_GROUP_FAIL:
      return {
        ...state,
        loadCreate: false,
      };
    case actionTypes.INVITE_MEMBERS_SUCCESS:
      return {
        ...state,
        dataInviteMembers: payload,
      };
    case actionTypes.INVITE_CUSTOMER_SUCCESS:
      return {
        ...state,
        dataInviteCustomer: payload,
      };
    case actionTypes.GET_LIST_BRIKS_ADD_TO_GROUP:
      return {
        ...state,
        loadingGetListBriksAddToGroup: true
      };
    case actionTypes.GET_LIST_BRIKS_ADD_TO_GROUP_FAIL:
      return {
        ...state,
        loadingGetListBriksAddToGroup: false
      };
    case actionTypes.GET_LIST_BRIKS_ADD_TO_GROUP_SUCCESS:
      return {
        ...state,
        listBriksAddToGroup: payload,
        loadingGetListBriksAddToGroup: false
      };
    case actionTypes.ADD_BRIKS_TO_GROUP:
      return {
        ...state,
        loadingCustomer: true
      };
    case actionTypes.ADD_BRIKS_TO_GROUP_FAIL:
      return {
        ...state,
        loadingCustomer: false
      };
    case actionTypes.ADD_BRIKS_TO_GROUP_SUCCESS:
      return {
        ...state,
        addBrikGroup: payload,
        loadingCustomer: false
      };
    default:
      return state;
  }
};